export default __webpack_public_path__ + "static/media/ai-hoty.9a0a8596.png";